import React from "react";
import { Alert, Skeleton } from "@mui/material";
import APPLE_STORE from "../../assets/app-stores/apple-store.png";
import PLAY_STORE from "../../assets/app-stores/play-store.png";

const SetGoogleAuthenticator = ({ qrCode, loadingQrCode }) => {
  return (
    <>
      <Alert
        variant="standard"
        severity="info"
        className="mt-3 mx-auto"
        style={{ maxWidth: "400px" }}
      >
        Set Google or Microsoft Authenticator
      </Alert>

      <div className="d-flex align-items-center flex-column justify-content-center mt-3">
        {!!qrCode && !loadingQrCode ? (
          <img src={qrCode} className="mb-1" alt="authenticator qrcode" />
        ) : (
          <Skeleton
            variant="rounded"
            width={150}
            height={150}
            className="mb-1"
          />
        )}
        <p className="text-left mb-2">
          Scan this QR Code with{" "}
          <span className="font-weight-bold">
            Google or Microsoft Authenticator
          </span>{" "}
          to get the code
        </p>
        <div className="text-center mb-2">
          <p className="mb-1">Don't have an authenticator app?</p>

          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={PLAY_STORE}
              alt="Google Play Store"
              style={{ maxWidth: "120px" }}
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/google-authenticator/id38849760"
            target="_blank"
            className="mr-1"
            rel="noreferrer"
          >
            <img
              src={APPLE_STORE}
              alt="Apple Store"
              style={{ maxWidth: "120px" }}
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default SetGoogleAuthenticator;
